/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect,
  useMemo,
  useRef
} from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppRoutes from '../../routes/AppRoutes';
import FullView from '../../views/FullView/fullview';
import BasicView from '../../views/BasicView/basicview';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { METADATA_KEY, VIEW_TABLE } from '../../utils/utils';
import SharedUtils from "../shared/Common/utils";
import IntercomService from '../../services/intercom.service';
import backendService from '../../services/backend.service';

const TIMEOUT_DURATION = 30 * 60 * 1000; // 30 minutes in milliseconds
const LAST_ACTIVITY_KEY = 'lastActivityTime';
const UPDATE_THRESHOLD = 10000; 

const ACTIVITY_EVENTS = [
  'mousedown',
  'mousemove',
  'keypress',
  'scroll',
  'touchstart',
  'focus'
];

const cleanApplicationStorage = () => {
  // keysToCheckForLocalStorage.forEach((key) => {
  //   const value = localStorage.getItem(key);
  //   if (value != null) {
  //     try {
  //       JSON.parse(value);
  //     } catch {
  //       localStorage.removeItem(key);
  //     }
  //   }
  // });
};

const App = () => {
  const navigate = useHistory();
  const location = useLocation();
  const authToken = useSelector((state) => state?.auth?.token);
  const lastActivityRef = useRef(Date.now());
  const lastStorageUpdateRef = useRef(Date.now());
  const metaAbortRef = useRef(null);

  const getMeta = async () => {
    metaAbortRef.current?.abort();
    metaAbortRef.current = backendService.createAbortController();
    const signal = metaAbortRef.current.signal;
    try {
      const response = await SharedUtils.apiPost("meta", {}, false, false, false, {
        signal
      });
      if(!signal.aborted && response && response.length > 0){
        const data = response[0];
        localStorage.setItem(METADATA_KEY, JSON.stringify(data));
        if (document.body) {
          window.dispatchEvent(new Event('metadata_loaded'));
        }
        IntercomService.bootIntercom();
      }
    } catch (error) {
      if (!backendService.isRequestCanceled(error)) {
        console.error("Error fetching metadata:", error);
      }
    }
  } 
  const currentView = useMemo(() => {
    const view = VIEW_TABLE[location.pathname];
    if (view) return view;
    if (location.pathname === '/' && authToken) return 'fullView';
    if(location.pathname.includes('/visibility/ext')) return 'fullView';
    if(location.pathname.includes('/visibility/saas')) return 'fullView';
    if(location.pathname.includes('/browser-health')) return 'fullView';
    return 'basicView';
  }, [location.pathname, authToken]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (
        !localStorage.getItem('reduxState') &&
        location.pathname !== '/login'
      ) {

        // Remove all opened popups when user logs out after inactivity
        const openedPopups = document.getElementById('react-confirm-alert');
        const openedPopupSvg = document.getElementById('react-confirm-alert-firm-svg');
        const saasAgreementPopup = document.getElementById('saasagreement-container');
        if (saasAgreementPopup) {
          saasAgreementPopup.remove();
        }
        if (openedPopups) {
          openedPopups.remove();
        }
        if (openedPopupSvg) {
          openedPopupSvg.remove();
        }
        localStorage.removeItem(METADATA_KEY);
        localStorage.removeItem('eventV2_verdict');
        IntercomService.shutdownIntercom();
        navigate.push('/login');
        return;
      }
      if (event.key === 'reduxState') {
        getMeta();
        navigate.push(event.newValue ? '/' : '/login');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [location.pathname]);

  useEffect(() => {
    const isLoginPath = location.pathname === '/login';

    const handleActivity = () => {
      const currentTime = Date.now();
      lastActivityRef.current = currentTime;
  
      if (currentTime - lastStorageUpdateRef.current >= UPDATE_THRESHOLD) {
        localStorage.setItem(LAST_ACTIVITY_KEY, currentTime.toString());
        lastStorageUpdateRef.current = currentTime;
      }
    };

    const checkInactivity = () => {
      const lastActivity = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY) || Date.now());
      const currentTime = Date.now();
      const inactiveTime = currentTime - lastActivity;

      if (inactiveTime >= TIMEOUT_DURATION && !isLoginPath) {
        IntercomService.shutdownIntercom();
        localStorage.removeItem('client_id');
        localStorage.removeItem('client_name');
        localStorage.removeItem('reduxState');
        localStorage.removeItem(METADATA_KEY);
        localStorage.removeItem(LAST_ACTIVITY_KEY);
        navigate.push('/login');
      }
    };

    handleActivity();
    ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    const intervalId = setInterval(checkInactivity, 30000);

    return () => {
      ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
      clearInterval(intervalId);
    };
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
    cleanApplicationStorage();
  }, [location.pathname]);

  useEffect(() => {
    if (authToken) {
      getMeta();
    }
    return () => {
      metaAbortRef.current?.abort();
    };
  }, [authToken]);

  return currentView === 'fullView' ? (
    <FullView>
      <AppRoutes />
    </FullView>
  ) : (
    <BasicView>
      <AppRoutes />
    </BasicView>
  );
};

export default App;